import React from 'react';
import { IonRow, IonCol } from '@ionic/react';
import './MopFooterPaymentSuccessPage.scss';

import { baseUrl } from '../helpers/configHelper';
import Button from './Button';

const MopFooterPaymentSuccessPage: React.FC = () => {
    function handleClick() {
        window.location.href = baseUrl() + "/splash?newOrder=true";
    }

    return (
        <div className="MopFooterInner PaymentSuccessPage">
            <IonRow className="ion-align-items-center">
                <IonCol size="12">
                    <Button
                        onClick={handleClick}
                        expand="block"
                        color="light"
                        size="small"
                        rounded
                    >
                        Start a new order
                    </Button>
                </IonCol>
            </IonRow>
        </div>
    );
};

export default MopFooterPaymentSuccessPage;
